// src/routes/PrivateRoute.js
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";

const PrivateRoute = ({ component: Component }) => {
    const token = localStorage.getItem("token");
    const location = useLocation();
    const [status, setStatus] = useState("loading"); // loading | authorized | unauthorized | invalidToken

    useEffect(() => {
        const validateToken = async () => {
            if (!token) {
                setStatus("invalidToken");
                return;
            }

            try {
                const response = await axios.post(
                    process.env.REACT_APP_VALIDARAC,
                    { ruta: location.pathname.toLowerCase() },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.data.success) {
                    setStatus("authorized");
                } else {
                    setStatus("unauthorized");
                }
            } catch (error) {
                if (error.response?.status === 403) setStatus("unauthorized");
                else setStatus("invalidToken");
            }
        };

        validateToken();
    }, [token, location.pathname]);

    if (status === "loading") return <div>Cargando...</div>;

    if (status === "invalidToken") {
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        return <Navigate to="/" replace />;
    }

    if (status === "unauthorized") return <Navigate to="/no-autorizado" replace />;

    // ✅ Solo renderiza la página si está autorizado y pasa isAuthorized al componente
    return <Component isAuthorized={status === "authorized"} />;
};

export default PrivateRoute;
